import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import { PickupPointInfo } from '@/routes/Brand/Requests/Request/components/shared/PickupPointInfo/PickupPointInfo';
import useViewPort from '@/utils/useViewport';

import { StepMessage } from '../../shared/StepMessage';

const QualityControl = ({ request }: { request: RequestWithRelations }) => {
  const { isMobile } = useViewPort();

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage
          message={
            <Paragraph size="50" color="secondary">
              <Trans id="client.request.quality-control.title">
                Your item is currently under quality control.
              </Trans>
            </Paragraph>
          }
        />

        <Stack gap={isMobile ? '1rem' : '1.5rem'}>
          <PickupPointInfo request={request} />
          <ClientArticlesList request={request} showPrice showArticleComment />
        </Stack>
      </Stack>
    </BrandRequestMainContent>
  );
};

export default QualityControl;
